import { render } from "./PickerDay.vue?vue&type=template&id=2d10169c"
import script from "./PickerDay.vue?vue&type=script&lang=js"
export * from "./PickerDay.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__